/**
 * Alt sayfalarda ortak üst şerit (başlık + isteğe bağlı alt başlık).
 * @param {{
 *   title: string,
 *   subtitle?: string,
 *   eyebrow?: string,
 * }} props
 */
export function SubpageBanner({ title, subtitle, eyebrow }) {
    return (
        <div className="subpage-banner">
            <img
                src="/assets/images/rotary-logo.svg"
                alt=""
                className="subpage-banner-logo"
                aria-hidden
            />
            <div className="container py-4 py-md-5 position-relative">
                {eyebrow ? (
                    <p className="subpage-banner-eyebrow mb-0">{eyebrow}</p>
                ) : null}
                <h1 className="subpage-banner-title">{title}</h1>
                {subtitle ? (
                    <p className="subpage-banner-subtitle mb-0">{subtitle}</p>
                ) : null}
            </div>
        </div>
    );
}
